import React, { useState, useEffect } from "react";
import styles from "./PluginsGroupsTab.module.css";
import Card from "shared/Card";
import SearchBar from "DreamStream/Shared/SearchBar";
import GroupPluginsList from "./GroupPluginsList";

import Loader from "shared/Loader";
import { usePlugins } from "../usePlugins";

/**
 * View component.
 * Handles the Plugins/Groups Tab for the Plugins page.
 */
export function PluginsGroupsTab({ plugins }) {
  // Determines which plugin's details are being viewed.
  // If null, the modal is closed.
  const { loading } = usePlugins();

  const [sortedPlugins, setSortedPlugins] = useState([]);

  useEffect(() => {
    if (plugins) {
      setSortedPlugins(plugins);
    }
  }, [plugins]);

  // Handle plugin search

  const onSearch = (searchText) => {
    const searchWords = searchText.trim().toLowerCase().split(/\s+/);
    console.log(searchWords);
    const newSort =
      searchText.length > 0
        ? plugins.filter((plugin) => {
            return searchWords.every(
              (word) =>
                String(plugin.plugeeIBONumber).includes(word) ||
                String(plugin.targetIBONumber).includes(word) ||
                String(plugin.plugeeBusinessType).includes(word) ||
                String(plugin.plugeeOrganizationName)
                  .toLowerCase()
                  .includes(word) ||
                String(plugin.targetOrganizationName)
                  .toLowerCase()
                  .includes(word) ||
                String(plugin.plugeeName).toLowerCase().includes(word) ||
                String(plugin.targetGroupName).toLowerCase().includes(word)
            );
          })
        : plugins;
    setSortedPlugins(newSort);
  };

  return (
    <>
      <div className={styles.subHeader}>
        Group Plugins is used to add an individual business to a DreamStream
        Group. That individual business is added as an Admin and will have the
        ability to Post and Share content.
      </div>
      <Card className={styles.cardContainer}>
        <div className={styles.header}>Group Plugins</div>

        <SearchBar
          onInput={(value) => onSearch(value)}
          placeholderText="Search by IBO, IBO Name, Organization Name, or Group Name"
          searchDelay={0}
          minChar={0}
          className={styles["search-bar"]}
          btn={true}
        />

        {loading && sortedPlugins ? (
          <Loader />
        ) : (
          <>
            <GroupPluginsList plugins={sortedPlugins} />
          </>
        )}
      </Card>
    </>
  );
}
